import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteFetch } from '@legacy/utils/fetcher';
import { GET_COMPETENCES_KEY } from '@legacy/apis/competencesAPI/types';
import {
  COMPETENCE_GROUPS_URL_PATH,
  GET_COMPETENCE_GROUPS_KEY,
} from '../types';

export const DELETE_COMPETENCE_GROUPS_MSW_STATUS_KEY = 'deleteCompetenceGroups';

export const DELETE_COMPETENCE_GROUPS_KEY = 'DELETE_COMPETENCES';

const deleteCompetenceGroups = (itemId?: number) =>
  deleteFetch({
    path: COMPETENCE_GROUPS_URL_PATH,
    key: DELETE_COMPETENCE_GROUPS_MSW_STATUS_KEY,
    itemId: `/${itemId}`,
  });

export const useDeleteCompetenceGroups = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: deleteCompetenceGroups,

    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [GET_COMPETENCE_GROUPS_KEY],
      });
      qc.invalidateQueries({
        queryKey: [GET_COMPETENCES_KEY],
      });
    },
  });
};
